import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SalesQuotation } from '@generated/models';
import QuotationsIcon from '@icons/custom/calculator.svg';
import { SvgIconComponent } from '@web/shared/components/svg-icon/svg-icon.component';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-quotation-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, RouterLink, NgTemplateOutlet, SvgIconComponent],
  template: `
    @let _quotation = quotation();
    @let _clickable = clickable();
    @let _size = size();

    @if (_clickable) {
      <a
        [routerLink]="['/', 'biddings', 'bids', _quotation.bid!.id, 'quotations', _quotation.id]"
        (click)="onClick($event)"
        class="h-fit w-fit leading-0 flex"
      >
        <ng-container [ngTemplateOutlet]="tag" />
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="tag" />
    }

    <ng-template #tag>
      @let _small = _size === 'small';
      <p-tag [class]="{ 'h-6': !_small, 'w-26': !_small, 'h-5': _small, 'w-20': _small }">
        <div class="flex items-center gap-1 px-1.5 whitespace-nowrap">
          <app-svg-icon [icon]="QuotationIcon" [class]="_small ? 'size-2' : 'size-3'" />

          <span [class]="_size === 'small' ? '!text-2xs' : '!text-sm'" class="font-bold">
            {{ _quotation.code }}
          </span>
        </div>
      </p-tag>
    </ng-template>
  `,
  styles: [
    `
      .p-tag {
        border: 1px solid var(--color-soe-petrol-blue);
        box-shadow: 2px 1px 0px 0px var(--color-soe-petrol-blue);
        --p-tag-primary-background: var(--color-white);
        padding: 0;
        --p-tag-primary-color: var(--color-black);
      }
    `,
  ],
})
export class QuotationTagComponent {
  readonly size = input<'small' | 'default'>('default');
  readonly clickable = input<boolean>(false);
  /** `bid` required only when `clickable` is true (used for routerLink). */
  readonly quotation = input.required<Pick<SalesQuotation, 'id' | 'code'> & { bid?: { id: string } }>();

  readonly QuotationIcon = QuotationsIcon;

  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
